import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";

const SITE = "https://www.deltapictures.it";
const OG_IMAGE = `${SITE}/images/dp-social-image.jpg`;

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href, extra = {}) {
  const sel = extra.hreflang ? `link[rel="${rel}"][hreflang="${extra.hreflang}"]` : `link[rel="${rel}"]`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("link");
    el.rel = rel;
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
    document.head.appendChild(el);
  }
  el.href = href;
}

export default function SEO({ title, description, noindex = false, path }) {
  const { lang } = useLang();
  const location = useLocation();
  const url = SITE + (path ?? location.pathname);

  useEffect(() => {
    document.title = title;
    document.documentElement.lang = lang;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, follow" : "index, follow");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:locale", lang === "it" ? "it_IT" : "en_US");
    setMeta("property", "og:image", OG_IMAGE);
    setMeta("property", "og:site_name", "Delta Pictures");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", OG_IMAGE);
    setLink("canonical", url);
    setLink("alternate", url, { hreflang: "it" });
    setLink("alternate", url, { hreflang: "en" });
    setLink("alternate", url, { hreflang: "x-default" });
  }, [title, description, noindex, url, lang]);

  return null;
}
